"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemIconOverrides = void 0;
var createMuiListItemIconOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            color: palette.text.secondary,
            minWidth: spacing(8),
            minHeight: spacing(8),
            alignItems: "center",
            justifyContent: "center",
        },
        alignItemsFlexStart: {
            marginTop: undefined,
        },
    });
};
exports.createMuiListItemIconOverrides = createMuiListItemIconOverrides;
//# sourceMappingURL=MuiListItemIcon.js.map